import { useEffect, useState } from 'react';
import { useSessionStore } from '@/state/session-store';
import { AgendaItem } from '@/components/AgendaItem';

export function AgendaPanel() {
  const { agenda, startedAt } = useSessionStore();
  const [, setTick] = useState(0);

  // Force re-render for urgency colors
  useEffect(() => {
    const interval = setInterval(() => setTick(t => t + 1), 1000);
    return () => clearInterval(interval);
  }, []);

  if (!agenda || !startedAt) return null;

  // Only count non-header items for coverage stats
  const trackableItems = agenda.items.filter(i => !i.isGroupHeader);
  const coveredCount = trackableItems.filter(i => i.covered).length;
  const totalCount = trackableItems.length;
  const percent = totalCount > 0 ? Math.round((coveredCount / totalCount) * 100) : 0;

  // Find the highest index of a covered non-header item
  const lastCoveredIndex = agenda.items.reduce((maxIdx, item, idx) =>
    (item.covered && !item.isGroupHeader) ? idx : maxIdx, -1);

  // An item is "skipped" if it's not covered, not a header, and a later item is covered
  const isSkipped = (index: number) =>
    !agenda.items[index].covered &&
    !agenda.items[index].isGroupHeader &&
    index < lastCoveredIndex;

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm text-gray-600">{coveredCount}/{totalCount} covered</span>
        <div className="flex-grow mx-3 h-1.5 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-green-500 rounded-full transition-all duration-300"
            style={{ width: `${percent}%` }}
          />
        </div>
        <span className="text-sm font-medium text-gray-700">{percent}%</span>
      </div>

      <div className="space-y-1 max-h-[800px] overflow-y-auto pr-1">
        {agenda.items.map((item, index) => (
          <AgendaItem
            key={item.id}
            item={item}
            sessionStartTime={startedAt}
            skipped={isSkipped(index)}
          />
        ))}
      </div>
    </div>
  );
}
